import { Route, Routes } from "react-router-dom"
import ActionPlans from "../pages/main"
import Form from "../pages/form"
import PlansToGenerate from "../pages/toGenerate"
import ToGenerateDetail from "../pages/toGenerateDetail"
import CreateActionPlan from "../pages/createActionPlan"
import CreateActionPlanManual from "../pages/createActionPlanManual"
import SolveActionPlan from "../pages/solveActionPlan"
import { ActionPlanProvider } from "../provider"

const ActionPlanRoutes = () => {
    return (
        <ActionPlanProvider>
            <Routes>
                <Route path="created" element={<ActionPlans />} />
                <Route path="created/:id" element={<Form />} />
                <Route path="to-generate" element={<PlansToGenerate />} />
                <Route path="to-generate/:id" element={<ToGenerateDetail />} />
                <Route path="to-generate/:id/create" element={<CreateActionPlan />} />
                <Route path="create" element={<CreateActionPlanManual />} />
                <Route path="created/:id/solve" element={<SolveActionPlan />} />
            </Routes>
        </ActionPlanProvider>
    )
}

export { ActionPlanRoutes }
